<div class="d-flex flex-wrap" [class.flex-column]="stacked">
  <button
    class="btn selector-btn mb-1 rating btn-light"
    *ngFor="let item of items; last as isLast; index as index"
    [class.btn-sm]="size === 'sm'"
    [class.btn-lg]="size === 'lg'"
    [class.selected]="isSelected(item)"
    [disabled]="disabled || (item.value | map: isItemDisabled:disabledItems)"
    [class.mr-1]="!stacked && !isLast"
    [class.mb-2]="size === 'lg'"
    [ngStyle]="{ 'min-width': minWidthCss }"
    (click)="onSelectItem(item, index)"
    (mouseenter)="onHoverItem(index)"
    (mouseleave)="onStopHovering()"
  >
    <div class="d-flex align-items-center">
      <div>
        <div class="custom-control custom-radio d-flex align-items-center">
          <input
            type="radio"
            class="custom-control-input"
            [name]="'select-' + id"
            [formControl]="control"
            [id]="item._id"
            [value]="item | map: getItemValue:bindValue"
          />

          <label [for]="item._id" class="custom-control-label" [class.text-primary]="isSelected(item)">
            {{
              translateLabels ? (item | map: getItemLabel:bindLabel | translate) : (item | map: getItemLabel:bindLabel)
            }}
          </label>
        </div>
        <div></div>
      </div>
    </div>
  </button>
</div>
